import { z } from "zod";

const EmployeeRefSchema = z.object({ id: z.string(), name: z.string() });
const GroupRefSchema = z.object({ id: z.string(), name: z.string() });

export const DateRangeSchema = z.enum(["all_time", "past", "upcoming"]);
export type DateRange = z.infer<typeof DateRangeSchema>;

export const CompanyMeetingsCoverageFiltersSchema = z.object({
	employee: EmployeeRefSchema.optional(),
	manager: EmployeeRefSchema.optional(),
	group: GroupRefSchema.optional(),
	dateRange: DateRangeSchema.optional(),
	withoutMeetings: z.boolean().optional(),
});
export type CompanyMeetingsCoverageFilters = z.infer<typeof CompanyMeetingsCoverageFiltersSchema>;

// Shape used by the filter-panel form. The "without meetings" checkbox is modeled as a
// checkbox group with a single option, matching the CompanyMeetings status filter pattern.
export const WITHOUT_MEETINGS_OPTION_VALUE = "withoutMeetings";

export const CompanyMeetingsCoverageFilterFormSchema = z.object({
	employee: EmployeeRefSchema.nullable().optional(),
	manager: EmployeeRefSchema.nullable().optional(),
	group: GroupRefSchema.nullable().optional(),
	dateRange: DateRangeSchema.default("all_time"),
	withoutMeetings: z.array(z.string()).default([]),
});
export type CompanyMeetingsCoverageFilterForm = z.infer<typeof CompanyMeetingsCoverageFilterFormSchema>;
